import { render, staticRenderFns } from "./dragDropEmailHeaderBlock.vue?vue&type=template&id=20c36582&"
import script from "./dragDropEmailHeaderBlock.vue?vue&type=script&lang=js&"
export * from "./dragDropEmailHeaderBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports